import { LocalStorageKey } from "../../Constants/constants";

export const getAuthToken = () => {
  return window.localStorage.getItem(LocalStorageKey.AUTH_TOKEN);
};
export const getLastAuthTokenUpdtTime = () => {
  const str = window.localStorage.getItem(LocalStorageKey.LAST_TOKEN_UPDATED);
  if(str) {
    return parseInt(str);
  }
  else {
    return 0;
  }
}
export const setAuthToken = (token) => {
  window.localStorage.setItem(LocalStorageKey.AUTH_TOKEN, token);
  window.localStorage.setItem(LocalStorageKey.LAST_TOKEN_UPDATED, new Date().getTime().toString());
};
export const destroyAuthToken = () => {
  window.localStorage.removeItem(LocalStorageKey.AUTH_TOKEN);
  window.localStorage.removeItem(LocalStorageKey.LAST_TOKEN_UPDATED);
};

export const getAuthUser = () => {
  const v = window.localStorage.getItem(LocalStorageKey.AUTH_USER);
  return (v == null || v == 'undefined') ? null : JSON.parse(v);
}
export const setAuthUser = (authUser) => {
  window.localStorage.setItem(LocalStorageKey.AUTH_USER, JSON.stringify(authUser));
}
export const destroyAuthUser = () => {
  window.localStorage.removeItem(LocalStorageKey.AUTH_USER);
}

export const setCurrentMenu = (menu) => {
  window.localStorage.setItem(LocalStorageKey.CURRENT_MENU, JSON.stringify(menu));
}
export const getCurrentMenu = () => {
  const v = window.localStorage.getItem(LocalStorageKey.CURRENT_MENU);
  return (v == null || v == 'undefined') ? null : JSON.parse(v);
}
export const destroyCurrentMenu = () => {
  window.localStorage.removeItem(LocalStorageKey.CURRENT_MENU);
}

export default { 
  getAuthToken, setAuthToken, destroyAuthToken,getLastAuthTokenUpdtTime,
  getAuthUser, setAuthUser, destroyAuthUser,
  getCurrentMenu, setCurrentMenu, destroyCurrentMenu,
};
